export default "__VITE_ASSET__BkjUZjwZ__"